module.exports = __webpack_public_path__ + "images/4f44b6d7e04bb1441c25208292f9f90c.jpg";